import React from 'react';
import { FRZNAdvertorial } from './components/FRZNAdvertorial';
export function App() {
  return <FRZNAdvertorial data-id="element-0" />;
}